<template>
  <svg width="40" height="40" viewBox="0 0 105 105" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M96.5 25H8.5" stroke="#42410b" stroke-width="4" stroke-linecap="round" />
    <path d="M96.5 52H8.5" stroke="#42410b" stroke-width="4" stroke-linecap="round" />
    <path d="M96.5 80H8.5" stroke="#42410b" stroke-width="4" stroke-linecap="round" />
  </svg>
</template>
